import { BranchQrisMerchantListPage } from "@/features/branch-qris-merchant/pages/BranchQrisMerchantListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/branch-qris-merchant/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["branch_qris_merchants.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: BranchQrisMerchantListPage,
});
